/**
 * CRM API Configuration
 * Base URL for CRM backend (separate from main backend on port 5000)
 *
 * The global axios interceptors from config.js handle token refresh for ALL axios instances.
 * This file provides the CRM base URL and convenience helpers.
 */

import axios from 'axios';

// CRM API runs on a separate port from the main API
export const CRM_API_URL = process.env.REACT_APP_CRM_API_URL || 'https://awrxknbwhr.us-west-2.awsapprunner.com';
export const MAIN_API_URL = process.env.REACT_APP_API_URL || 'https://vwwjda2e99.us-west-2.awsapprunner.com';
export const CRON_API_URL = process.env.REACT_APP_CRON_API_URL || 'https://sunridge-cron.exitech.org';

/**
 * Get authorization config for CRM requests
 * Named differently from config.js getAuthHeaders to avoid barrel-export conflict.
 * The token is managed by config.js interceptors, but some CRM helpers
 * still pass headers explicitly for clarity.
 */
export const getCrmAuthConfig = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('sessionToken')}` },
});

/**
 * Shorthand for authenticated CRM GET requests using global axios
 */
export const crmGet = (path, params) =>
  axios.get(`${CRM_API_URL}${path}`, { ...getCrmAuthConfig(), params });

/**
 * Shorthand for authenticated CRM POST requests using global axios
 */
export const crmPost = (path, data, config = {}) =>
  axios.post(`${CRM_API_URL}${path}`, data, { ...getCrmAuthConfig(), ...config });

/**
 * Shorthand for authenticated CRM PUT requests using global axios
 */
export const crmPut = (path, data) =>
  axios.put(`${CRM_API_URL}${path}`, data, getCrmAuthConfig());

/**
 * Shorthand for authenticated CRM PATCH requests using global axios
 */
export const crmPatch = (path, data) =>
  axios.patch(`${CRM_API_URL}${path}`, data, getCrmAuthConfig());

/**
 * Shorthand for authenticated CRM DELETE requests using global axios
 */
export const crmDelete = (path, data) =>
  axios.delete(`${CRM_API_URL}${path}`, { ...getCrmAuthConfig(), data });

/**
 * Shorthand for main API requests (port 4000)
 */
export const mainGet = (path, params) =>
  axios.get(`${MAIN_API_URL}${path}`, { ...getCrmAuthConfig(), params });

export const mainPost = (path, data, config = {}) =>
  axios.post(`${MAIN_API_URL}${path}`, data, { ...getCrmAuthConfig(), ...config });

/**
 * Shorthand for cron-backend requests from the frontend.
 */
export const cronGet = (path, params) =>
  axios.get(`${CRON_API_URL}${path}`, { ...getCrmAuthConfig(), params });
